import { render } from "./GestionGasDashboard.vue?vue&type=template&id=89013b7c&scoped=true"
import script from "./GestionGasDashboard.vue?vue&type=script&lang=js"
export * from "./GestionGasDashboard.vue?vue&type=script&lang=js"

import "./GestionGasDashboard.vue?vue&type=style&index=0&id=89013b7c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89013b7c"]])

export default __exports__